import { ReactNode } from "react";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import { useAppContext } from "@/src/config/AppProvider";

const ContactSection = (): ReactNode => {
  const { t } = useTranslation();
  const { licenceSettings } = useAppContext();

  return (
    <div className="row g-5">
      <div className="col-lg-4 col-md-6 col-sm-6 col-12 sal-animate" data-sal="slide-up" data-sal-delay="150" data-sal-duration="800">
        <div className="rbt-address">
          <div className="icon">
            <i className="feather-phone"></i>
          </div>
          <div className="inner">
            <h4 className="title">{t("contactPhoneNumber")}</h4>
            <p>{licenceSettings.PhoneNumber}</p>
            <p>{licenceSettings.MobilePhoneNumber}</p>
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 col-sm-6 col-12 sal-animate" data-sal="slide-up" data-sal-delay="150" data-sal-duration="800">
        <div className="rbt-address">
          <div className="icon">
            <i className="feather-mail"></i>
          </div>
          <div className="inner">
            <h4 className="title">{t("ourEmailAddress")}</h4>
            <p>
              <Link href={`mailto:${licenceSettings.ContactEmail}`}>{licenceSettings.ContactEmail}</Link>
            </p>
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 col-sm-6 col-12 sal-animate" data-sal="slide-up" data-sal-delay="150" data-sal-duration="800">
        <div className="rbt-address">
          <div className="icon">
            <i className="feather-map-pin"></i>
          </div>
          <div className="inner">
            <h4 className="title">{t("ourLocation")}</h4>
            <p>{licenceSettings.Address}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
